<div *qmLoading="loading" style="width: 100%;">
  <table class="table table-sm table-borderless">
    <tbody>
    <tr *ngFor="let cause of causes">
      <td>{{cause.cause}}</td>
      <td>{{cause.count}}</td>
    </tr>
    </tbody>
  </table>
</div>
